import React from 'react';
import './QuarantineModal.css';

// ─── Helpers ───────────────────────────────────────────────────────────────

function getObjectType(obj) {
  const raw = obj?.data?.type || obj?.data?.content?.type || '';
  if (!raw) return 'Unknown Object';
  const parts = raw.split('::');
  // Show last 2 segments — e.g. "token::TOKEN"
  return parts.slice(-2).join('::') || raw;
}

function getObjectId(obj) {
  return obj?.data?.objectId || '';
}

function shortId(id) {
  if (!id) return 'Unknown ID';
  return `${id.slice(0, 8)}...${id.slice(-6)}`;
}

// ─── Main Component ────────────────────────────────────────────────────────

function QuarantineModal({ quarantinedObjects, onClose, onReturnItem, isToiletMode }) {
  return (
    <div
      className={`quarantine-modal-overlay${isToiletMode ? ' toilet-mode' : ''}`}
      onClick={onClose}
    >
      <div
        className={`quarantine-modal${isToiletMode ? ' toilet-mode' : ''}`}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <h2 className="quarantine-modal-title">
          ⚠️ Quarantined Objects
        </h2>
        <p className="quarantine-modal-subtitle">
          {quarantinedObjects.length} object{quarantinedObjects.length !== 1 ? 's' : ''} flagged as malicious
        </p>

        {/* Warning */}
        <div className="quarantine-warning-banner">
          <span className="quarantine-warning-icon">🚨</span>
          <span>
            These objects were blocked by your wallet's security system — they contain
            malicious code that activates on interaction. They cannot be deleted through
            Distil. Report them to Slush wallet support.
          </span>
        </div>

        {/* Object List */}
        <div className="quarantine-objects-list">
          {quarantinedObjects.map((obj, i) => {
            const id = getObjectId(obj);
            const type = getObjectType(obj);
            return (
              <div key={id || i} className="quarantine-object-item">
                <span className="quarantine-object-icon">☣️</span>
                <div className="quarantine-object-info">
                  <span className="quarantine-object-type">{type}</span>
                  <span className="quarantine-object-id">{shortId(id)}</span>
                </div>
                <div className="quarantine-object-actions">
                  {id && (
                    <a
                      href={`https://suiscan.xyz/mainnet/object/${id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="quarantine-view-link"
                      onClick={e => e.stopPropagation()}
                    >
                      View ↗
                    </a>
                  )}
                  {id && onReturnItem && (
                    <button
                      className="quarantine-return-btn"
                      onClick={e => { e.stopPropagation(); onReturnItem(id); }}
                      title="Remove from quarantine and return to cleanup list"
                    >
                      ↩ Return
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* Report row */}
        <div className="quarantine-report-row">
          <span className="quarantine-report-label">📧 Report to Slush:</span>
          <span className="quarantine-report-email">support@mystenlabs.com</span>
        </div>

        {/* Actions */}
        <div className="quarantine-actions">
          <button className="quarantine-close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default QuarantineModal;
